export default {
  taprequestManagement: (state) => state,
  results: (state) => state.results,
  studentSIE: (state) => state.studentSIE,
};
